import * as orderComplexTypes from '~constants/order_complex_types';

export default {
  data() {
    return {
      useNullableOrderComplexType: true,
    };
  },
  computed: {
    orderComplexTypeItems() {
      const items = [];
      if (this.useNullableOrderComplexType) {
        items.push({
          text: this.lang(this.$store, 'sap/listings.global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(orderComplexTypes)
        .forEach((key) => {
          if (key !== 'COMPLEX_TYPES') {
            items.push({
              text: this.lang(this.$store, `sap/listings.global.filter.order_complex_types.${orderComplexTypes[key]}`),
              value: orderComplexTypes[key],
            });
          }
        });
      return items;
    },
  },
};
